/**
 * Application root.
 *
 * Composes the providers every route depends on, in the order they depend on
 * each other: the query client is outermost because auth uses it, and the
 * router is innermost because its guards read the session.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md tasks 5.1, 5.8, 5.9, 5.13
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { IconSprite } from '../components/ui/IconSprite';
import { AuthProvider } from '../features/auth/AuthProvider';

import { createQueryClient } from './query-client';
import { router } from './router';

/* Created once at module scope rather than per render: a client rebuilt on
   every render would discard the cache each time. */
const queryClient = createQueryClient();

export function App(): React.JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <IconSprite />
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
